import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { ItemTax, OrderItem } from "../../../../../objects/orders/orderItem";
import { TaxType } from "../../../../../objects/orders/taxType";
import { NgFor } from "@angular/common/src/directives";
import { NgForm } from "@angular/forms";
import { Tax } from "../../../../../objects/orders/tax";
import { TaxHelper } from "../../../../../common/helpers/tax.helper";

@Component({
    selector: "clearance-option",
    templateUrl: "clearance-option.component.html",
    moduleId: module.id.toString()
})
export class ClearanceOptionComponent {

    @Input()
    public orderItem: OrderItem;

    @Input()
    public form: NgForm;

    @Input()
    public index: number;

    @Output()
    public valueChanged: EventEmitter<number> = new EventEmitter();

    @ViewChild('orderItemsFrom') orderItemsFrom: NgForm;

    public get bbFeeTax() {
        return TaxHelper.getItemTaxOrNull(this.orderItem, TaxType.AAFee);
    }

    public get bbFeeValue(): number {
        let tax = this.bbFeeTax;

        return !tax ? 0 : tax.Value.roundToDigits( 2);
    }

    public set bbFeeValue(value: number) {
        let tax = this.bbFeeTax;

        tax.Value = +value;
    }

    public isValid(): boolean {
        return this.orderItemsFrom.valid;
    }
}


// WEBPACK FOOTER //
// ./app/components/calculator/cards/currency-card/clearance-option/clearance-option.component.ts